<template>
    <v-container grid-list-md>
        <modules-rework-student-wrapper v-if="showReworksBlock()" :key="$route.fullPath"/>
    </v-container>
</template>

<script>
    import ModulesReworkStudentWrapper from "../../components/reworks/reworkModules/ModulesReworkStudentWrapper";

    export default {
        components: {
            ModulesReworkStudentWrapper
        },
        methods: {
            showReworksBlock() {
                return this.$route.params.department && this.$route.params.subject;
            },
        },
    }
</script>